import { copy } from '@/helpers/object';

const state = () => ({
  data: [],
  isFetching: false,
});

// mutations
const mutations = {
  setData(currentState, newValue = []) {
    currentState.data = copy(newValue);
  },
  setFetching(currentState, newValue) {
    currentState.isFetching = newValue;
  },
};

// actions
const actions = {
  fetch({ commit }) {
    commit('setFetching', true);
    // todo: change it to get it from appSetup
    return this.$api
      .get(this.getters.getApiLink('search.lastSearches'))
      .then(({ data }) => {
        const lastSearchList = data?.payload?.content;
        commit('setData', lastSearchList);
        return lastSearchList;
      })
      .finally(() => {
        commit('setFetching', false);
      });
  },
};
// actions end

const getters = {
  isFetching: (s) => s.isFetching,
  lastSearchList: (s) => s.data,
  lastSearchListCount: (s) => s.data.length,
};

export default {
  namespaced: true,

  mutations,
  state,
  actions,
  getters,
};
